import CustomSpin from '../../../elements/CustomSpin'
import React from 'react'
import { Card, Col, Icon, Row, Tag, Tooltip } from 'antd'
import { get, upperFirst } from 'lodash'
import { strVal } from '../../../modules/Utils'
import Avatar from '../../People/Member/Avatar'

function Details (props) {
  const { member, lender, fetching } = props

  console.log({ lender })
  const styleIcon = {
    paddingTop: '10px',
    marginRight: '5px',
    fontSize: 16,
    color: '#08c',
  }

  const InfoLine = ({ tooltip, icon, label, fallout = 'N/A' }) => (
    <Row style={{ marginRight: '15px', marginLeft: '10px', fontSize: '12pt' }}>
      <Tooltip placement="right" title={tooltip}>
        <Icon type={icon} style={styleIcon}/>
        {label || fallout}
      </Tooltip>
    </Row>
  )

  return (
    <Row>
      <Card title={<h1 style={{ fontWeight: 'bold' }}>{member.fn}</h1>} bordered={false}>
        <CustomSpin spinning={fetching}>
          <Col span={5} style={{ margin: 'auto' }}>
            <Avatar id={member._key}/>
          </Col>

          <Col span={19} style={{ margin: 'auto', paddingTop: '15px' }}>
            <h1 className={'icon-text-header'}>
              <Icon type="barcode" style={styleIcon}/>
              <Tooltip title="Finance Partner Code">{strVal(lender, 'code')}</Tooltip>
              {get(member, 'tags', []).map(tag => (
                <Tag color="#2db7f5" style={{ marginLeft: 10 }}>
                  {upperFirst(tag)}
                </Tag>
              ))}
            </h1>

            <InfoLine
              {...{ tooltip: 'Home Address', icon: 'home', label: strVal(member, 'address.label') }}
            />
            <InfoLine
              {...{ tooltip: 'Phone Number', icon: 'phone', label: strVal(member, 'phone.label') }}
            />
            <InfoLine
              {...{
                tooltip: 'Mobile Number',
                icon: 'mobile',
                label: strVal(member, 'mobile.label'),
              }}
            />
            <InfoLine
              {...{ tooltip: 'Email Address', icon: 'mail', label: strVal(member, 'email.label') }}
            />
          </Col>
        </CustomSpin>
      </Card>
    </Row>
  )
}

export default Details
